<div [kalLoading]="loading">
    <div>

        <kal-card class="activityAdvancedPayment">

            <kal-card-header>

                <kal-card-title *ngIf="!paymentMethodDatasource.isRefundContext">
                    Règlement en mode avancé
                </kal-card-title>

                <h5 class="gup-O-titrage__subTitle">{{title}}</h5>

            </kal-card-header>

            <kal-card-content class="activityAdvancedPayment__table">

                <kal-table
                    [class.no-action]="!selection"
                    [columns]="columns"
                    [dataSource]="dataSource"
                    [displayedColumns]="displayedColumns"
                    [selection]="selection">

                    <!-- add header row -->
                    <tr *kalHeaderRowDef kal-header-row></tr>
                    <tr *kalFooterRowDef kal-footer-row></tr>

                    <!-- Libelle facture -->
                    <ng-container kalColumn="Libelle">
                        <td *kalBodyCell="let row">
                            <div [class.gup-U-stronger]="shouldDisplayAllInvoices && currentInvoice.Id === row.Id">
                                {{ row.Libelle }}
                            </div>
                        </td>
                        <td *kalFooterCell
                            class="gup-U-stronger">
                            <strong>Total</strong>
                        </td>
                    </ng-container>

                    <!-- Montant facture -->
                    <ng-container kalColumn="MontantFactureTotal">
                        <td *kalBodyCell="let row"> {{ row.MontantFactureTotal | currency:'EUR' }}</td>
                        <td *kalFooterCell>
                            {{ countTotalInvoicesAmount | currency:'EUR'}}
                        </td>
                    </ng-container>

                    <!-- Montant avoir / acompte -->
                    <ng-container kalColumn="ListeFactureImpute">
                        <td *kalBodyCell="let row">{{ getCreditDepositAmount(row) | currency:'EUR' }}</td>
                        <td *kalFooterCell>
                            {{ countCreditsDepositsAmount | currency:'EUR' }}
                        </td>
                    </ng-container>

                    <!-- Montant à régler / remboursé -->
                    <ng-container kalColumn="Solde">
                        <th *kalHeaderCell>{{ isRefund ? 'Montant à rembourser' : 'Montants à régler'}}</th>
                        <td *kalBodyCell="let row">{{ row.Solde | currency:'EUR' }}</td>
                        <td *kalFooterCell>
                            <strong>{{ countTotalAmountToPay | currency:'EUR' }}</strong>
                        </td>
                    </ng-container>

                    <!-- Montants réglés -->
                    <ng-container kalColumn="MontantControl">
                        <th *kalHeaderCell>{{ isRefund ? 'Montant remboursé' : 'Montant réglé'}}</th>
                        <td *kalBodyCell="let row">
                            <kal-form-field [displayErrors]="false"
                                            class="without-label">
                                <kal-input (click)="stopPropagation($event)"
                                           [formControl]="row.MontantControl"
                                           icon="euro"
                                           type="currency">
                                </kal-input>
                            </kal-form-field>
                        </td>
                        <td *kalFooterCell>
                            <strong>{{ countTotalEditedAmount | currency:'EUR' }}</strong>
                        </td>
                    </ng-container>

                </kal-table>
                <div i18n
                     *ngIf="!shouldInvoiceListValid"
                     class="gup-U-color--red">
                    {dataSource.length, plural,
                        one {Le montant réglé ne peut pas être supérieur à {{currentInvoiceMaxAmount | currency: 'EUR'}}.}
                        other {Les montants réglés ne peuvent pas être supérieurs aux montants des factures.}
                    }
                </div>

            </kal-card-content>

            <kal-card-actions>

                <div class="gup-C-flexGroup -row -justifyBetween -alignEnd">

                    <div class="gup-C-flexGroup__item gup-C-flexGroup -column">

                        <a (click)="openCreditsDepositsDialog()"
                           *ngIf="shouldDisplayOpenCreditDepositDialog"
                           class="gup-O-link -secondary">
                            Imputer avoir et acompte
                        </a>

                        <ng-container *ngIf="hasMoreThanOneInvoice">

                            <a (click)="openInvoicesList()"
                               *ngIf="!shouldDisplayAllInvoices else validSelectionTemplate"
                               class="gup-O-link gup-O-status -is-validated">
                                {{ invoicesLinkLabel }}
                                <kal-icon>keyboard_arrow_down</kal-icon>
                            </a>

                            <ng-template #validSelectionTemplate>

                                <kal-button (click)="closeInvoicesList()"
                                            [disabled]="!hasInvoicesSelected"
                                            kalTheme="primary">
                                    Valider la sélection
                                </kal-button>

                            </ng-template>

                        </ng-container>

                    </div>

                    <div class="gup-C-flexGroup__item">

                        <a (click)="toggleShouldEditAmount()"
                           class="gup-O-link -secondary">
                            {{ editAmountLabel }}
                        </a>

                    </div>

                </div>

                <div class="activityAdvancedPayment__leftToPay">
                    Reste à {{isRefund ? 'rembourser' : 'payer' }} :
                    <span [ngClass]="{'gup-U-color--red': amountToPay < 0}">
                    {{ amountToPay | currency:'EUR' }}
                </span>
                </div>

            </kal-card-actions>

        </kal-card>

    </div>

    <div [formGroup]="form"
         class="paymentMethods">

        <div *ngFor="let settlement of settlementsArray.controls; index as i" formArrayName="settlements">

            <div [formGroupName]="i">

                <div *ngIf="!(settlement.get('isAdded').valueChanges | async) else settlementDetailTemplate">

                    <kal-card>

                        <kal-card-content>

                            <app-shared-payment-methods [datasource]="paymentMethodDatasource"
                                                          [maxAmount]="maxAmount"
                                                          [paymentType]="paymentType"
                                                          formControlName="settlement">
                            </app-shared-payment-methods>

                        </kal-card-content>

                        <kal-card-actions>

                            <kal-button (click)="applySettlement(i)"
                                        [disabled]="settlementsArray.disabled || settlement.invalid"
                                        id="activity_advanced_payment_apply"
                                        kalTheme="primary">
                                Appliquer
                            </kal-button>

                            <kal-button (click)="deleteSettlement(i)"
                                        [disabled]="settlementsArray.disabled"
                                        id="activity_advanced_payment_cancel"
                                        kalTheme="secondary">
                                Annuler
                            </kal-button>

                        </kal-card-actions>

                    </kal-card>

                </div>

                <ng-template #settlementDetailTemplate>

                    <kal-card *ngIf="settlement.get('settlement').value as settlementInformations"
                              class="gup-C-cardLine">
                        <kal-card-content class="gup-C-cardLine__content">

                            <div class="col1">

                                <span>{{ getPaymentMethodLabel(settlementInformations) }}</span>

                                <span *ngIf="isChequeNumberDisplayed(settlementInformations)"
                                      class="gup-U-color--400">
                                  - N° {{ settlementInformations?.NumCheque }}
                            </span>

                            </div>

                            <div class="col2">

                                <span>{{ settlementInformations.MontantReglement | currency:'EUR' }}</span>

                            </div>

                            <kal-icon (click)="deleteSettlement(i)" class="col3">
                                clear
                            </kal-icon>

                        </kal-card-content>

                    </kal-card>

                </ng-template>

            </div>

        </div>

        <a (click)="addSettlement()"
           *ngIf="areAllSettlementsValid && !shouldDisplayAllInvoices && amountToPay !== 0"
           class="gup-C-moreInfos gup-O-link"
           id="activity_advanced_payment_add_payment">

            <kal-icon>add</kal-icon>

            <span>Ajouter un règlement</span>

        </a>

    </div>

</div>
